import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { toggleSearchMenu, resetFilters, search } from '../../state/actions';
import { getSelectedFilterCount } from '../../state/utils';
import { StateType } from '../../../state/state.types';

const mapState = ({ queryParams, aggregations, results }: StateType) => {
  const shouldShowLawFilter = queryParams.type === 'law';
  const shouldShowPreparatoryWorkFilter =
    queryParams.type === 'preparatory_work';
  const shouldShowCommentaryOrDecisionFilter =
    (Object.keys(aggregations).length > 0 ||
      queryParams.aggregationsPaths.length ||
      queryParams.parties.plaintiff ||
      queryParams.parties.defendant ||
      queryParams.excludeMoyensAnnexes ||
      queryParams.dates.from ||
      queryParams.dates.to) &&
    (queryParams.type === 'commentary' || queryParams.type === 'arret');
  return {
    selectedFiltersLength: getSelectedFilterCount({
      queryParams,
    }),
    showFilters:
      results.loaded &&
      (shouldShowLawFilter ||
        shouldShowCommentaryOrDecisionFilter ||
        shouldShowPreparatoryWorkFilter),
    exceptExpressions: results?.exceptExpressions,
  };
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  closeFilter() {
    dispatch(toggleSearchMenu());
  },
  resetFilters() {
    dispatch(resetFilters());
    dispatch(search({ reason: 'reset' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
